import React, { useState } from 'react'
import TagManager from 'react-gtm-module'
import './oferta.scss'
import moment from 'moment-timezone'
import { GatsbyImage } from 'gatsby-plugin-image'

export default function Oferta (data) {
  const { oferta } = data
  const [ofertaLike, setOfertaLike] = useState(oferta.like)
  // console.log(data)

  const setFavorito = (oferta) => {
    if (!oferta.category || oferta.category?.type !== 'BANNER') {
      oferta.like = !oferta.like
      setOfertaLike(oferta.like)
      if (oferta.like) {
        const tagManagerArgs = {
          dataLayer: {
            event: 'Tabloide',
            eventAction: 'like',
            eventLabel: oferta.image.url,
            tabloideTarifa: data.idTarifa
          }
        }

        console.log(tagManagerArgs)

        TagManager.dataLayer(tagManagerArgs)
      }
      data.handleClick(oferta)
    }
  }

  return (
    <div className="hvr-grow" style={oferta.style}>
      {!oferta.category || oferta.category?.type !== 'BANNER'
        ? <>
          <GatsbyImage style={{ width: '100%', height: 'auto' }}
            image={oferta.image.childImageSharp.gatsbyImageData}
            alt={`${oferta.tag ? oferta.tag : `Oferta de ${oferta.category?.name}`}`}
            onClick={() => setFavorito(oferta)}
          />
          <button
            type="button"
            // style={oferta.category.name === 'Banner' ? { display: 'none' } : estilo}
            aria-label={`Botão para favoritar oferta de ${oferta.category?.name}`}
            className={ofertaLike ? 'like ativado' : 'like desativado'}
            onClick={() => setFavorito(oferta)}
          />
          <div style={validStyle}>
            <small style={oferta.category?.name === 'Banner' ? { display: 'none' } : validTextStyle}>Válida até {moment.utc(oferta.finishDate).tz('America/Sao_Paulo').format('DD/MM/YYYY')}</small>
          </div>
        </>
        : <a href={oferta.linkBanner} target="_blank" rel="noreferrer" >
          <GatsbyImage style={{ width: '100%', height: 'auto' }}
            image={oferta.image.childImageSharp.gatsbyImageData}
            alt={`${oferta.tag ? oferta.tag : `Banner de ${oferta.category?.name}`}`}
            // onClick={() => setFavorito(oferta)}
          />
        </a>
      }
    </div>
  )
}

const estilo = {
  backgroundColor: 'transparent',
  outline: 0,
  border: 0
}

const validStyle = {
  zIndex: 1,
  position: 'absolute',
  bottom: '-2px',
  textAlign: 'center',
  width: '100%'
}

const validTextStyle = {
  background: '#fff',
  color: '#333',
  padding: '3px 5px 1px',
  opacity: '0.8'
}
